export default "__VITE_ASSET__b2d154b6__"